import { FILTER_ENUMS } from 'search/enums/constants';

/**
 * [shouldShowSellerImage] if used filter applied, and picture_url exists in cheapestProduct
 * then we should show the seller image
 * @param query
 * @param cheapestProduct
 */
export const getSellerImage = (query, cheapestProduct) => {
  if (!query?.[FILTER_ENUMS.CONDITION] || !cheapestProduct) return false;

  // seller image
  const sellerImage = JSON.parse(cheapestProduct)?.picture_url;
  if (!sellerImage) return false;

  // check if Used filter is applied
  const productCondition = query[FILTER_ENUMS.CONDITION];
  const isUsedFilterApplied = Array.isArray(productCondition)
    ? productCondition.includes('used')
    : productCondition === 'used';

  if (isUsedFilterApplied) {
    return sellerImage;
  }

  return false;
};
